export const baseURL = '/api/form'
export const RESOURCES_LOCAL_URL = ''
export const RESOURCES_STAGING_URL = '//resources.emazestaging.com/forms'
export const RESOURCES_PRODUCTION_URL = '//resources.emaze.com/forms'